import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiClient } from '@app/core/services/base-api-client.service';
import { LoadingIndicatorService } from '@app/core/services/loading-indicator.service';
import { LogService } from '@app/core/services/log.service';
import { Environment } from '@env/environment';
import { Observable, catchError, tap } from 'rxjs';
import { Language } from '../models/language';

const httpOptions = {
	headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};
export interface ILanguageService {
	url: string;
	getLanguage(): Observable<Language>;
}
@Injectable({
	providedIn: 'root',
})
export class LanguageService extends BaseApiClient implements ILanguageService {
	/**
	 * The base URL for the API domain.
	 */
	public baseUrl: string;

	/**
	 * The URL to the API endpoint.
	 */
	public url: string;

	constructor(
		private readonly http: HttpClient,
		private readonly log: LogService,
		private readonly loadingIndicatorService: LoadingIndicatorService,
		environment: Environment
	) {
		super();
		this.baseUrl = environment.services['employee'];
		this.url = this.baseUrl + 'Language';
	}

	/**
	 * Get Language for an employee
	 */
	getLanguage(): Observable<Language> {
		const url = `${this.url}`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.get<Language>(url, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
	/**
	 * Update default language
	 * @param languageId
	 */
	postLanguage(languageId: number): Observable<boolean> {
		const url = `${this.url}/Insert?languageId=${languageId}`;
		const errorHandler = this.createErrorResponseHandler(this.log, undefined, (_) => this.loadingIndicatorService.stopLoading());

		this.loadingIndicatorService.startLoading();
		return this.http.post<boolean>(url, null, httpOptions).pipe(
			tap((result) => {
				this.loadingIndicatorService.stopLoading();
			}),
			catchError(errorHandler)
		);
	}
}
